import React from 'react'
import ReactDOM from 'react-dom/client'
import localforage from 'localforage';
import {
    createBrowserRouter,
    RouterProvider
} from "react-router-dom";
import App from './App.tsx'
import './index.css'
import { FallbackComponent } from './components/ErrorBoundary.tsx'

import * as Sentry from "@sentry/react";



Sentry.init({
    dsn: "https://59cb530b7c8d41ede5e722809822e2a8@o557196.ingest.sentry.io/4506349041549312",
    integrations: [
        new Sentry.BrowserTracing({
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: ["localhost", /^https:\/\/guac\.fancyhands\.com/],
        }),
        new Sentry.Replay(),
    ],

    // Performance Monitoring
    tracesSampleRate: 0.5, // Capture X% of the transactions

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.

    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    // Ignore dev
    enabled: import.meta.env.PROD
});




const router = createBrowserRouter([{
    path: 'logout',
    element: <pre style={{ margin: "3em" }}>Successfully logged out.<br /><a href="/login">Log In again</a></pre>,
    loader: () => {
        // just make sure it happens.
        setTimeout(() => {
            if (navigator.serviceWorker) {
                navigator.serviceWorker.getRegistrations().then(function (registrations) {
                    for (let registration of registrations) {
                        console.log("unregistering", registration);
                        registration.unregister();
                    }
                }
                );
            }
            localforage.clear();
        }, 1);
        return null;
    }
},
{
    path: "/*",
    element: <App />
},
]);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
            <RouterProvider router={router} />
        </Sentry.ErrorBoundary>
    </React.StrictMode>,
);
